import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PublicRedirectPage = () => {
  const { slug, token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | error
  const [error, setError] = useState('');
  const [tenantName, setTenantName] = useState('');
  const [tenantColor, setTenantColor] = useState('#1e3a8a');

  useEffect(() => {
    resolve();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, token]);

  const resolve = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/public/resolve/${slug}/${token}`);
      if (data.tenant_name) setTenantName(data.tenant_name);
      if (data.tenant_color) setTenantColor(data.tenant_color);
      if (data.capturar_dados) {
        // redirect to capture form (replace history so back doesn't loop)
        navigate(`/${slug}/c/${token}`, { replace: true });
        return;
      }
      if (data.whatsapp_url) {
        // Quick brand frame then redirect
        setTimeout(() => {
          window.location.href = data.whatsapp_url;
        }, 700);
        return;
      }
      setStatus('error');
      setError('Destino inválido');
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.detail || 'Link não encontrado ou expirado');
    }
  };

  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
        <div className="max-w-sm w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
          <div className="h-12 w-12 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto mb-4 text-2xl font-black">
            !
          </div>
          <h1 className="text-lg font-bold text-slate-900 mb-2">Ops!</h1>
          <p className="text-sm text-slate-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: `linear-gradient(135deg, ${tenantColor}10, ${tenantColor}05)` }}
    >
      <div className="max-w-sm w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-10 text-center">
        <div
          className="h-14 w-14 rounded-2xl flex items-center justify-center mx-auto mb-5"
          style={{ background: tenantColor }}
        >
          <Loader2 className="h-7 w-7 text-white animate-spin" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 mb-2">
          Direcionando você...
        </h1>
        <p className="text-sm text-slate-500">
          {tenantName ? `Conectando com ${tenantName} no WhatsApp` : 'Conectando com o WhatsApp'}
        </p>
      </div>
    </div>
  );
};
